import apiClient from './client';

/** One redemption of a referral code (referee view). */
export interface RedemptionSummary {
  referee_name: string;
  redeemed_at: string;
  reward_due_at: string;
  referrer_rewarded_at: string | null;
  referee_rewarded_at: string | null;
  referrer_skipped_reason: string | null;
  referee_skipped_reason: string | null;
}

/** User's referral code with all redemptions. */
export interface MyCodeSummary {
  code: string;
  is_revoked: boolean;
  redemptions: RedemptionSummary[];
}

/** User's redemption of someone else's code (referee view). */
export interface RefereeSummary {
  referrer_name: string;
  redeemed_at: string;
  reward_due_at: string;
  rewarded_at: string | null;
  skipped_reason: string | null;
}

export interface MyReferralResponse {
  my_code: MyCodeSummary;
  redeemed_as_referee: RefereeSummary | null;
}

export interface ValidateReferralRequest {
  code: string;
}

export interface ValidateReferralResponse {
  valid: boolean;
  referrer: { name: string; is_active: boolean } | null;
  reward_preview: string | null;
  error_key: string | null;
}

export async function getMyReferral(): Promise<MyReferralResponse> {
  const response = await apiClient.get<MyReferralResponse>('/referrals/me');
  return response.data;
}

export async function validateReferralCode(code: string): Promise<ValidateReferralResponse> {
  const response = await apiClient.post<ValidateReferralResponse>('/referrals/validate', { code });
  return response.data;
}
